import styled from 'styled-components';

export const SpinnerStyles = styled.div`
    .overlay-container {
        height: 100vh;
        width: 100%;
        z-index: 2;
        background: rgba(230, 230, 230, 0.2);
        justify-content: center;
        padding: 0px 10px;
        border-radius: 10px;
        position: absolute;
        .spinner::after {
            content: '';
            box-sizing: border-box;
            width: 40px;
            height: 40px;
            position: absolute;
            top: 50%;
            left: 50%;
            border-radius: 50%;
        }

        .spinner.material::after {
            border-top: 4px solid #37baea;
            border-left: 4px solid #37baea;
            border-bottom: 4px solid transparent;
            border-right: 4px solid rgba(255, 255, 255, 0);
            animation: spinner 0.6s linear infinite;
        }
        @keyframes spinner {
            to {
                transform: rotate(360deg);
            }
        }
    }
`;

const MapStyles = styled.div`
    // Google map fix...
    .gm-style-moc {
        height: unset !important;
    }

    .map {
        background: inherit;
    }
`;

export default MapStyles;
